import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { StorageService } from '../../lib/storage.service';
import { LogService } from '../../lib/log.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ModalService } from '../../lib/modal.service';
import { AssessmentAlert } from '../../components/assessment-alert/assessment-alert';
import { AssessmentResilienceAlert } from '../../components/assessment-resilience-alert/assessment-resilience-alert';
import { User } from '../../../app/models/user';
import { Organization } from '../../../app/models/organization';
import { Assessment } from '../../../app/models/assessment';
import { UserService } from '../../../app/lib/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import jQuery from 'jquery';
import { Subscription } from 'rxjs';
import { AssessmentService } from 'app/lib/assessment.service';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { AssessmentStateService } from '../../lib/assessment-state.service';
interface Answer {
    comment: string;
    isAnswered: boolean;
    value: number | string; // Supports single number or text input
    values: Record<string, number>; // Object to store selected checkbox values
    name: any;
    id: any;
    type: any;
    bufferIncremented: boolean;
    fieldDisabled: boolean;
    answerType: string;
}

@Component({
    selector: 'app-mental-wellbeing-assessment',
    templateUrl: './mental-wellbeing-assessment.component.html',
    styleUrls: ['./mental-wellbeing-assessment.component.scss'],
    standalone: false,
})
export class MentalWellbeingAssessmentComponent implements OnInit {
    isLoaded = false;
    questions: Array<any> = [];
    answers: Answer[] = [];
    active = 0;
    count = 0;
    alerts: string;
    user: User;
    popup: any;
    quizType: string = 'dass';
    showExplain: boolean = false;
    showScore: boolean = false;
    showIntro: boolean = false;
    assessment: Assessment;
    organization: Organization;
    forced: boolean;
    submitting: boolean;
    title: string;
    back: string;
    backLink: string;
    cssClass: string;
    headerImage: string;
    resiliencyLevel: string;
    resiliencyDescription: string;
    alert: boolean;
    buffer = 0;
    progress = 0;
    progressValue: any;
    optionType: any;
    showAnimation: boolean = false;
    typeAssessment: string;
    assessmenttranslation: any;
    returnPath: any;
    showEmptyHeader: boolean = false;
    existingGoal: string = '';
    goalQuestionIndex: number = -1;
    initalAssessmentQuestionIndex: number = -1;
    isInitalAssessment: number;
    selectedStarIndex: number = 0;
    rating: number = 0;
    goalSubscription: Subscription;
    textAreaValue = '';
    endUserId: any;
    popups: any;
    goalOptionQuestionIndex: number = -1;
    constructor(
        private api: ApiService,
        private modalService: ModalService,
        private log: LogService,
        private storage: StorageService,
        private router: Router,
        private userService: UserService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private location: Location,
        public assessmentService: AssessmentService,
        private assessmentState: AssessmentStateService
    ) {
        this.user = this.userService.getUser();
        this.submitting = false;
        this.route.queryParams.subscribe(params => {
            this.endUserId = params['userId'];
        });
         const storedGoal = this.storage.get('existingGoal');
        if (storedGoal) {
            this.existingGoal = storedGoal;
            this.textAreaValue = storedGoal;
        }
        this.goalSubscription =
            this.assessmentService.MWAcurrentGoalSubject.subscribe(data => {
                if (data  && data.trim()) {
                    this.textAreaValue = this.existingGoal = data;
                    this.storage.set('existingGoal', data);
                }
            });
    }

    ngOnInit() {
         const storedGoal = this.storage.get('existingGoal');
            if (storedGoal && !this.existingGoal) {
                this.existingGoal = storedGoal;
                this.textAreaValue = storedGoal;
            }
        this.translate.stream('error').subscribe((res: any) => {
            this.popup = res.title;
        });
        this.translate
            .stream('dynamicAssessment.mentalwellbeing.popup')
            .subscribe((res: any) => {
                this.popups = res;
            });
        this.isInitalAssessment = this.user.mentalWellbeingInitial;
        this.activatedRoute.params.subscribe((params: Params) => {
            if (params['assessment']) {
                this.quizType = params['assessment'];
            }
            this.translate
                .stream('assessments.' + this.quizType)
                .subscribe((res: any) => {
                    this.assessmenttranslation = res;
                    this.title = res.title;
                    this.back = res.back;
                });

            if (this.quizType === 'mentalwellbeing') {
                this.activatedRoute.queryParams.subscribe(queryParams => {
                    this.forced = queryParams['forced'];
                    this.returnPath = queryParams['path'];
                });
                if (this.returnPath === 'onboarding') {
                    this.showEmptyHeader = true;
                }
            }
        });

        this.questions = [];
        this.answers = [];
        this.api.get('form/' + this.user.mentalWellbeingAssessment).subscribe(
            (result: any) => {
                const objs = result.data;
                this.setAssessmentQuestionData(objs);
                if (
                    this.user?.primaryOrganization?.id &&
                    this.quizType === 'mentalwellbeing'
                ) {
                    this.getResourceQuestions();
                } else {
                    this.isLoaded = true;
                }

                this.progressValue = 100 / this.count;
                this.progress = this.progressValue;
            },
            (error: any) => {
                this.log.event(
                    AnalyticEvent.event.assessmentQuestionsFetchError
                );
                this.log.error(
                    'Error getting assessment questions. ' + error.message
                );
            }
        );
        this.assessmentState.setAssessmentActive(true);
    }

    getResourceQuestions() {
        this.api
            .get('organizations/' + this.user.primaryOrganization.id)
            .subscribe(
                (result: any) => {
                    this.organization = new Organization(result.data, 'view');
                    // if (this.organization.settings.assessment !== 'resilience') {
                    this.orgQuestions();
                    this.isLoaded = true;
                    // }
                },
                (error: any) => {
                    this.progressValue = 100 / this.count;
                    this.progress = this.progressValue;
                    this.buffer = this.progressValue;
                    this.isLoaded = true;
                    this.log.error(
                        'Error getting organizations. ' + error.message
                    );
                }
            );
    }

    setAssessmentQuestionData(questionslist: any[]) {
        questionslist.forEach((questionWrapper, questionIndex) => {
            const question = questionWrapper[0];
            const group = question.Group;

            // Skip rating/goal-option questions on initial assessment
            if (
                this.isInitalAssessment &&
                ['rating-question', 'goaloption-question'].includes(group)
            ) {
                return;
            }
            if (
                group === 'goaloption-question' &&
                this.goalOptionQuestionIndex === -1
            ) {
                this.goalOptionQuestionIndex = questionIndex;
            }
            if (group === 'goal-question') {
                if (this.goalQuestionIndex === -1) {
                    this.goalQuestionIndex = questionIndex;
                }
                if (this.isInitalAssessment) {
                    // Keep goal question in the question array during initial
                    this.textAreaValue = '';
                    this.prepareAssessmentQuestion(question, group);
                    this.questions.push(question);
                    this.count++;
                }
            } else {
                this.prepareAssessmentQuestion(question, group);
                this.questions.push(question);
                if (
                    group === 'assessment-question' &&
                    this.initalAssessmentQuestionIndex === -1
                ) {
                    this.initalAssessmentQuestionIndex = questionIndex;
                }

                this.count++;
            }

            this.answers.push(this.buildAssessmentAnswer(question));
        });
    }

    private prepareAssessmentQuestion(question: any, group: string) {
        question.questionType = 'assessmentQuestion';
        question.isAnswered = false;
        question.showExistingGoal = group === 'rating-question';

        question.options?.forEach((option: any) => (option.checked = 0));
        question.options?.sort((a: any, b: any) => a.SortOrder - b.SortOrder);
    }

    private buildAssessmentAnswer(question: any) {
        const isTextType = question.Type === 5;
        const value = isTextType
            ? this.isInitalAssessment
                ? ''
                : this.existingGoal
            : -1;
        const fieldDisabled = isTextType
            ? this.isInitalAssessment
                ? false
                : true
            : false;
        return {
            comment: question.Comment,
            answerType: 'assessmentAnswer',
            isAnswered: false,
            value: value,
            values: {},
            name: isTextType ? question.options[0].ID : -1,
            id: question.ID,
            type: question.Type,
            fieldDisabled: fieldDisabled,
            bufferIncremented: false,
        };
    }

    orgQuestions() {
        // for each on question set.  loop and add answers
        let lang = this.getLangForResourceList();
        if (
            this.organization.resourceSet.length &&
            this.organization.enableResources
        ) {
            let resourcesQuestions = [];
            this.organization.resourceSet.forEach(qs => {
                if (qs.language == lang) {
                    resourcesQuestions.push({
                        Type: 3,
                        Comment: qs.title,
                        Group: 'Organization',
                        ID: qs.id,
                        options: [
                            {
                                OptionValue: 0,
                                Comment: 'No',
                            },
                            {
                                OptionValue: 1,
                                Comment: 'Yes',
                            },
                        ],
                    });

                    this.answers.push({
                        comment: '',
                        answerType: 'resourceAnswer',
                        isAnswered: true,
                        value: 0,
                        values: {},
                        name: -1,
                        id: qs.id,
                        type: 3,
                        fieldDisabled: false,
                        bufferIncremented: false,
                    });
                }
            });
            if (resourcesQuestions.length) {
                resourcesQuestions.push(this.addNoneResourceQuestion());
                this.questions.push({
                    questionType: 'resourceQuestion',
                    isAnswered: false,
                    resourceQuestions: resourcesQuestions,
                });
                this.count++;
            }
        }
        this.progressValue = 100 / this.count;
        this.progress = this.progressValue;
    }

    addNoneResourceQuestion() {
        this.answers.push({
            comment: '',
            answerType: '',
            isAnswered: false,
            value: 0,
            values: {},
            name: -1,
            id: 'none',
            type: 3,
            fieldDisabled: false,
            bufferIncremented: false,
        });
        return {
            Type: 3,
            Comment: 'None',
            Group: 'Organization',
            ID: 'none',
            options: [
                {
                    OptionValue: 0,
                    Comment: 'No',
                },
                {
                    OptionValue: 1,
                    Comment: 'Yes',
                },
            ],
        };
    }

    getLangForResourceList() {
        let selectedLang = this.storage.get('lang');
        if (
            (selectedLang === 'fr' || selectedLang === 'es') &&
            !this.hasResourceByLangage(selectedLang)
        ) {
            selectedLang = 'en';
        }
        return selectedLang;
    }

    hasResourceByLangage(lang: string): boolean {
        return this.organization.resourceSet.some(r => r['language'] === lang);
    }

    setGoalData(setExistingGoal: boolean) {
        this.answers[this.goalQuestionIndex].value = setExistingGoal
            ? this.existingGoal
            : '';
        this.textAreaValue = setExistingGoal ? this.existingGoal : '';
        this.answers[this.goalQuestionIndex].fieldDisabled = setExistingGoal
            ? true
            : false;
        if (
            this.answers[this.goalQuestionIndex].value &&
            this.answers[this.goalQuestionIndex].fieldDisabled
        ) {
            this.answers[this.goalQuestionIndex].isAnswered = true;
            this.questions[this.active].isAnswered = true;
        } else {
            this.answers[this.goalQuestionIndex].isAnswered = false;
            this.questions[this.active].isAnswered = false;
        }
    }

    onSubmit() {
        if (this.answers[this.active]['value'] === -1) {
            return;
        }
        let answerData = [...this.answers];
        answerData = answerData.filter(
            (obj: Answer) => 'id' in obj && obj.id !== 'none'
        );
        // this.answers.forEach(answer => {
        //     delete answer.bufferIncremented;
        // });
        this.submitting = true;
        this.showAnimation = true;
        this.assessmentState.setAssessmentActive(false);
        this.api
            .post('assessment/save', {
                Type: this.quizType,
                Data: JSON.stringify(answerData),
                OrgQuestions: {},
            })
            .subscribe(
                (results: any) => {
                    this.api.get('users/me').subscribe(
                        (result: any) => {
                            this.showAnimation = false;
                            this.assessment = new Assessment(results.data);
                            this.log.event(
                                AnalyticEvent.event
                                    .mentalwellbeingAssessmentSubmitted
                            );
                            this.user.mentalWellbeingShowForm = false;
                            this.user = new User(result.data);
                            this.userService.setUser(this.user);
                            this.router.navigate([
                                '/app/assessment/result',
                                this.assessment.id,
                                this.assessment.type,
                            ]);
                            this.submitting = false;
                        },
                        (error: any) => {
                            this.log.error(
                                'Error fetching user profile: ' + error.message
                            );
                        }
                    );
                },
                (error: any) => {
                    this.log.event(AnalyticEvent.event.assessmentSubmitError);
                    this.modalService.showAlert(this.popup, error.message);
                    this.log.error('Error registering. ' + error.message);
                    this.submitting = false;
                }
            );
    }

    scrollToTop() {
        let element = document.getElementById('page-assessment');
        element.scrollIntoView();
    }

    setNextActive() {
        const isBeforeInitialAssessment =
            !this.showIntro &&
            this.active + 1 === this.initalAssessmentQuestionIndex;
        const isAtInitialAssessment =
            this.showIntro &&
            this.active === this.initalAssessmentQuestionIndex;
        if (isBeforeInitialAssessment) {
            this.showIntro = true;
        } else if (isAtInitialAssessment) {
            this.showIntro = false;
        } else {
            this.active = this.active + 1;
            this.showIntro = false;
            if (this.buffer < this.progress) {
                this.buffer += this.progressValue;
            }
            this.progress += this.progressValue;
        }
    }

    setIntro(intro) {
        this.showIntro = intro;
        // this.focusOnFirst();
    }

    setPreviousActive() {
        if (this.active === 0) {
            this.showIntro = false;
            return;
        } else {
            if (
                !this.showIntro &&
                this.active == this.initalAssessmentQuestionIndex
            ) {
                this.showIntro = true;
            } else {
                this.showIntro = false;
                this.active = this.active - 1;
                this.progress -= this.progressValue;
            }
        }
    }

    isSelected(index: number, optionID: string): boolean {
        return (
            this.answers[index]?.values[optionID] !== undefined &&
            this.answers[index].values[optionID] !== 0
        );
    }

    isAnyOptionSelected(index: number): boolean {
        return Object.values(this.answers[index]?.values || {}).some(
            value => value === 1
        );
    }

    /*
        question position, answer position,  type of question (1,2), question ID
        type 1: single answer
        type 2: multiple answers
        type 3: yes/no
    */
    onSelectionChange(
        i: number,
        value: any,
        question: any,
        optionID: string,
        questionType?
    ) {
        this.optionType = optionID;
        const index =
            !this.isInitalAssessment &&
            this.active > this.goalOptionQuestionIndex
                ? i + 1
                : i;
        if (question.Type === 1) {
            // Single-select (radio)
            this.answers[index].value = value;
            this.answers[index].name = optionID;
            this.answers[index].isAnswered = true;
            if (question.Group == 'goaloption-question') {
                this.setGoalData(value < 2);
                this.answers[index].isAnswered = true;
            } else {
                question.isAnswered = this.answers[index].isAnswered = true;
            }
            !['rating-question', 'goaloption-question'].includes(
                question.Group
            ) &&
                setTimeout(() => {
                    this.setNextActive();
                }, 100);
        } else if (question.Type === 2) {
            // Multi-select (checkbox)
            if (this.answers[index].values[optionID]) {
                delete this.answers[index].values[optionID];
            } else {
                this.answers[index].values[optionID] = value;
            }
            question.isAnswered = this.answers[index].isAnswered =
                Object.keys(this.answers[index].values).length > 0;
        } else if (question.Type === 3) {
            if (questionType == 'resourceQusetion') {
                this.answers[index]['value'] =
                    this.answers[index]['value'] == 0 ? 1 : 0;
            } else {
                this.answers[index]['value'] = value;
            }
            if (this.answers[index]['id'] == 'none') {
                if (this.answers[index]['value'] == 1) {
                    this.answers.forEach((element: any) => {
                        element.answerType == 'resourceAnswer'
                            ? (element.value = 0)
                            : '';
                    });
                    question.isAnswered = this.answers[index]['isAnswered'] =
                        true;
                    questionType == 'resourceQusetion' &&
                        (this.questions[this.questions.length - 1][
                            'isAnswered'
                        ] = true);
                } else {
                    question.isAnswered = this.answers[index]['isAnswered'] =
                        false;
                    questionType == 'resourceQusetion' &&
                        (this.questions[this.questions.length - 1][
                            'isAnswered'
                        ] = false);
                }
            } else {
                if (this.answers[index]['answerType'] == 'resourceAnswer') {
                    let hasItem = this.answers.some(
                        (element: Answer) =>
                            element.answerType == 'resourceAnswer' &&
                            element.value == 1
                    );
                    this.questions[this.questions.length - 1]['isAnswered'] =
                        hasItem ? true : false;
                    hasItem
                        ? (this.answers[this.answers.length - 1]['value'] = 0)
                        : '';
                    question.isAnswered = this.answers[this.answers.length - 1][
                        'isAnswered'
                    ] = hasItem ? true : false;
                } else {
                    question.isAnswered = this.answers[index]['isAnswered'] =
                        true;
                }
            }
            if (value === 0 && index < this.count - 1) {
                this.setNextActive();
            }
        } else if (question.Type === 5) {
            // Text input
            this.answers[index].value = value;
            this.answers[index].name = optionID;
            question.isAnswered = this.answers[index].isAnswered = !!value;
        } else {
            // Other types
            this.answers[index].value = value;
            this.answers[index].name = optionID;
            question.isAnswered = this.answers[index].isAnswered = value
                ? true
                : false;
        }

        // Only increment the buffer the first time the question is marked as answered
        // if (this.answers[i].isAnswered && this.answers[i].bufferIncremented !== true) {
        //     this.buffer += this.progressValue;
        //     this.answers[i].bufferIncremented = true; // Avoid re-incrementing
        // };
    }

    checkAllAnswered() {
        let hasItem = this.questions.some(
            (item: any) => item.isAnswered == false
        );

        // let hasItem = !this.answers.some((item: Answer) => !item.isAnswered || !this.answers[this.goalQuestionIndex]?.value);
        return hasItem ? false : true;
    }

    onCancel() {
        this.router.navigateByUrl('/app/assessment');
    }

    goBack() {
        if (this.returnPath === 'onboarding') {
            this.router.navigate(['/app']);
        } else {
            this.location.back();
            this.assessmentState.setAssessmentActive(false);
        }
    }

    ngOnDestroy() {
        if (this.goalSubscription) {
            this.goalSubscription.unsubscribe();
        }
        this.assessmentState.setAssessmentActive(false);
    }

    backList() {
        this.modalService
            .showConfirmation(
                this.popups.exit,
                this.popups.exitMsg,
                this.popups.yes,
                this.popups.no
            )
            .afterClosed()
            .subscribe(result => {
                if (result) {
                    this.isLoaded = false;
                    if (this.user.userType != 'user' && this.endUserId) {
                        let url =
                            '/professional/user-details-dashboard/' +
                            this.endUserId;
                        this.router.navigate([url]);
                    } else {
                        let url =
                            '/app/assessment/' + this.quizType + '/listing';
                        this.router.navigate([url]);
                    }
                }
            });
    }

    onChangeGoaltext(question: any) {
        this.answers[this.goalQuestionIndex].value = this.textAreaValue;
        this.answers[this.goalQuestionIndex].isAnswered = this.answers[
            this.goalQuestionIndex
        ].value
            ? true
            : false;
        question.isAnswered = this.answers[this.goalQuestionIndex].value
            ? true
            : false;
            this.storage.set('existingGoal', this.textAreaValue);
    }
}
